import { Rad } from '../../lib/types/models/rad/rad'
import { RadInput } from '../../lib/types/models/rad/rad-input'
import { UpdateInput } from '../../lib/types/utils'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function updateRad(data: UpdateInput<RadInput>) {
  const { id, ...rest } = data

  return restApiClient
    .url(constructApiUrl(API.rads.update.url, { id }))
    .patch<Rad, Partial<RadInput>>(rest)
}
